{
    "appId": "com.matrixfitness.mea2",
    "appName": "mea2",
    "webDir": "www/browser",
    "bundledWebRuntime": false,
    "backgroundColor": "#000000",
    "server": {
        "androidScheme": "http"
    },
    "plugins": {
        "CapacitorHttp": {
            "enabled": true
        }
    }
}
